/**
 * The Home container
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux'
import { push } from 'connected-react-router'
import { Container, TabContent, TabPane, Nav, NavLink, NavItem, Modal, ModalHeader, ModalBody } from 'reactstrap';
// import {setLanguage} from "redux-i18n";
import classnames from "classnames";
import Page from '../components/Page'
import LoadingContent from '../components/LoadingContent'
import { Offline } from "react-detect-offline";
import { frontloadConnect } from 'react-frontload';
import xapiActions from '../redux/xapis';
import popUpsActions from '../redux/popUps';
import CMSBlock from '../components/CMSBlock';
import closeicon from '../assets/icons/icon-close.svg'
import {isServer} from "../redux/store";

/** frontload async calls */
const frontload = async props => {
  const {loadedHome} = props;
  const loadDate = new Date(loadedHome);
  const now = new Date();
  const someTimeAgo = now.setMinutes(now.getMinutes()-5);
  if (!loadedHome || loadDate < someTimeAgo){
    return await props.loadHome();
  }
}
/**
 * Selects props from the store and passes them to the component
 * @param {Object} state the store
 */
const mapStateToProps = state => ({
  home: state.xapis.home,
  loadingHome: state.xapis.loadingHome,
  loadedHome: state.xapis.loadedHome,
  homePopUpShown: state.popUps.homePopUpShown
})
/**
 * Binds dispatch method to the actions passed as props to the component
 */
const mapDispatchToProps = dispatch => bindActionCreators({
  loadHome: xapiActions.loadHome,
  setPopUpShown: popUpsActions.setPopUpShown,
  navigateTo: push
  },
  dispatch
)

/**
 * Home container used as app default landing page
 */
export class Home extends Component {
  constructor(props) {
    super(props);
    let modal = false;
    if (!props.homePopUpShown && !isServer) {
      modal = true
    }
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
      modal
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  toggleModal() {
    const {homePopUpShown, setPopUpShown} = this.props;
    if (!homePopUpShown) {
      setPopUpShown('home')
    }
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  render() {
    const {home, loadingHome} = this.props

    const closeBtn = 
    <button className="close text-danger" onClick={this.toggleModal}>
      <img src={closeicon} width="18px" height="18px" alt={this.context.t("Schließen")}/>
      <span className='sr-only'>{this.context.t("Schließen")}</span>
    </button>;


    return (
      <Page
        id="home"
        className='home'
        title={this.context.t('Verstehen')}
        description={this.context.t('Die REHADAT App hilft bei der Erstellung individueller Inklusionsvereinbarungen')}
        >
        { loadingHome && <LoadingContent showText={!home}/> }
        <Container>
          <Offline polling={false}>
          <h1>{this.context.t("Home.header.offline")}:</h1>
          </Offline>
        </Container>
        { home &&
        <div>
          
          {  home.cms_blocks && home.cms_blocks.home_content &&
            <section className="home__cmsblock pt-3">
              <CMSBlock
                cmsblock={home.cms_blocks.home_content}
                hasInfoButton={home.cms_blocks && home.cms_blocks.home_faq}
                toggleModal={this.toggleModal.bind(this)}
                headinglevel="1"
                />
              {home.cms_blocks.home_content2 && 
                <CMSBlock cmsblock={home.cms_blocks.home_content2}/>
              }
            </section>
          }
          { home.cms_blocks && home.cms_blocks.home_faq &&
            <div>
              {/* { !this.state.modal &&  */}
              {/* <Button color="link" onClick={this.toggleModal} className="btn home__infobutton">
                <i className="fa fa-info-circle" aria-hidden="true" />
                <span className='sr-only'>{this.context.t("Das ist ist ein Hilfstext, wie die App genutzt werden kann. Dieser Text kann durch den Infobutton auf der Seite 'Verstehen' wieder geöffnet werden.")}</span>
              </Button> */}
              {/* } */}
              
              <Modal isOpen={this.state.modal} toggle={this.toggleModal} className={"checklists__hero__modal"} centered>
                <ModalHeader toggle={this.toggleModal} close={closeBtn} className='checklists__hero__modal__header'>
                  <i className="fa fa-info-circle text-muted mr-3" aria-hidden="true" />
                  {home.cms_blocks.home_faq.title}</ModalHeader>
                <ModalBody>
                  <div dangerouslySetInnerHTML={{__html: home.cms_blocks.home_faq.text}} />
                </ModalBody>
              </Modal>
            </div>
                  
          }
          { home.cms_blocks && (home.cms_blocks.home_tab1 || home.cms_blocks.home_tab2 || home.cms_blocks.home_tab3) &&
          <section className='home__tabsection'>
            <Container>
              <Nav tabs role='tablist'>
                { home.cms_blocks.home_tab1 && 
                  <NavItem>
                  <NavLink
                    className={classnames({ active: this.state.activeTab === '1' },'h4')}
                    onClick={() => { this.toggle('1'); }}
                    id='home-tab-1'
                    data-toggle="tab"
                    role="tab"
                    aria-controls='panel1'
                    aria-selected={this.state.activeTab === '1'}
                    //tabIndex={0}
                    href='#panel1'
                  >
                    {home.cms_blocks.home_tab1.title}
                  </NavLink>
                </NavItem>
                }
                { home.cms_blocks.home_tab2 && 
                  <NavItem>
                    <NavLink
                      className={classnames({ active: this.state.activeTab === '2' },'h4')}
                      onClick={() => { this.toggle('2'); }}
                      id='home-tab-2'
                      data-toggle="tab"
                      role="tab"
                      aria-controls='panel2'
                      aria-selected={this.state.activeTab === '2'}
                      //tabIndex={0}
                      href='#panel2'
                    >
                      {home.cms_blocks.home_tab2.title}
                    </NavLink>
                  </NavItem>
                }
                { home.cms_blocks.home_tab3 && 
                  <NavItem>
                    <NavLink
                      className={classnames({ active: this.state.activeTab === '3' },'h4')}
                      onClick={() => { this.toggle('3'); }}
                      id='home-tab-3'
                      data-toggle="tab"
                      role="tab"
                      aria-controls='panel3'
                      aria-selected={this.state.activeTab === '3'}
                      //tabIndex={0}
                      href='#panel3'
                    >
                      {home.cms_blocks.home_tab3.title}
                    </NavLink>
                  </NavItem>
                }
                </Nav>
            </Container>
            <TabContent activeTab={this.state.activeTab}>
              { home.cms_blocks.home_tab1 && 
                <TabPane tabId="1" role="tabpanel" aria-labelledby="home-tab-1" id="panel1">
                  <CMSBlock cmsblock={home.cms_blocks.home_tab1} hideTitle />
                </TabPane>
              }
              { home.cms_blocks.home_tab2 && 
                <TabPane tabId="2" role="tabpanel" aria-labelledby="home-tab-2" id="panel2">
                  <CMSBlock cmsblock={home.cms_blocks.home_tab2} hideTitle />
                </TabPane>
              }
              { home.cms_blocks.home_tab3 && 
                <TabPane tabId="3" role="tabpanel" aria-labelledby="home-tab-3" id="panel3">
                  <CMSBlock cmsblock={home.cms_blocks.home_tab3} hideTitle />
                </TabPane>
              }
              </TabContent>
          </section>
          }
        </div>
        }
      </Page>
    );
  }
}

/**  define proptype for the 'translation' function  */
Home.contextTypes = {
  t: PropTypes.func
}

/** export the component as redux connected component */
export default connect(mapStateToProps, mapDispatchToProps)(
  frontloadConnect(frontload, {
    onMount: true,
    onUpdate: false,
  }
)(Home));